import { render, staticRenderFns } from "./agentList.vue?vue&type=template&id=226393c0&scoped=true&"
import script from "./agentList.vue?vue&type=script&lang=ts&"
export * from "./agentList.vue?vue&type=script&lang=ts&"
import style0 from "./agentList.vue?vue&type=style&index=0&id=226393c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226393c0",
  null
  
)

export default component.exports